<template>
    <v-card class="mb-3">
        <v-card-title>
            <v-layout row justify-space-between>
                <div class="title">{{title | capitalize}}</div>
                <div class="mr-3">{{$t('total') | capitalize}}: {{total | formatNumber}}</div>
            </v-layout>
        </v-card-title>
        <v-card-text class="pt-0">
            <v-form v-model="formValid">
                <v-layout row ma-0>
                    <v-flex mr-3>
                        <DatePicker
                            v-model="fromDate"
                            :label="$filters.capitalize($t('from'))"
                            :max="toDate"
                        ></DatePicker>
                    </v-flex>
                    <v-flex mr-3>
                        <DatePicker
                            v-model="toDate"
                            :label="$filters.capitalize($t('to'))"
                            :min="fromDate"
                            :max="today"
                        ></DatePicker>
                    </v-flex>
                    <v-flex class="centerY">
                        <v-btn-toggle v-model="filterRange" mandatory>
                            <v-btn flat v-for="item in filtersItems" :key="item.value" :value="item.value">
                                {{item.text}}
                            </v-btn>
                        </v-btn-toggle>
                    </v-flex>
                    <v-flex class="centerY">
                        <v-btn @click="update">{{$t('update')}}</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>
        <div>
            <LineChart ref="lineChart"></LineChart>
        </div>
    </v-card>
</template>

<script>
import moment from 'moment'
import DatePicker from '@/modules/fptai/components/DatePicker'
import VueCharts from 'vue-chartjs'

export default {
    name: 'ViewGeneral',
    components: { DatePicker, LineChart: VueCharts.Line },
    data () {
        return {
            total: 0,
            fromDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            filterRange: 'month',
            labels: [],
            data: [],
            formValid: true
        }
    },
    computed: {
        title () {
            return ''
        },
        filtersItems () {
            return [
                { text: this.$t('day'), value: 'day' },
                { text: this.$t('week'), value: 'week' },
                { text: this.$t('month'), value: 'month' }
            ]
        },
        timeSeries () {
            let timeSeries = []
            let unit = this.filterRange
            let start = moment(this.fromDate).startOf(unit)
            let end = moment(this.toDate).endOf('day')
            while (start.valueOf() < end.valueOf()) {
                timeSeries.push(start.valueOf())
                start.add(1, unit)
            }
            timeSeries.push(end.valueOf())
            timeSeries[0] = moment(this.fromDate).startOf('day').valueOf()
            return timeSeries
        },
        timeFormat () {
            return this.$const.DATE_FORMAT
            // return this.filterRange === 'month' ? this.$const.MONTH_FORMAT : this.$const.DATE_FORMAT
        }
    },
    mounted () {
        this.$appService.hideLoading()
        this.update()
    },
    methods: {
        update () {
            // to be implemented by inheritor
        },
        getDatasets () {
            // to be implemented by inheritor
        },
        validateForm () {
            if (this.timeSeries.length > 31) {
                this.$appService.toastError(this.$t('tooMuchTimeStamp', [this.timeSeries.length, 30]))
                return false
            }
            if (!this.formValid) {
                return false
            }
            return true
        },
        renderChartUser () {
            if (this.$refs.lineChart) {
                this.$refs.lineChart.renderChart({
                    labels: this.labels,
                    datasets: this.getDatasets()
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: true
                    }
                })
            }
        }
    }
}
</script>

<style scoped>

</style>
